var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "multiple_client_select",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "multiple_client_select" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "multiple_client_select_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("multipleClientSelect.title")) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "multiple_client_select_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("multiple_client_select")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "87vh", position: "relative" },
        },
        [
          _c("div", { staticClass: "bb-input-group search-input" }, [
            _c("i", { staticClass: "fas fa-search" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("multipleClientSelect.searchPlaceholder"),
              },
              domProps: { value: _vm.searchTerm },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTerm = $event.target.value
                },
              },
            }),
            _c(
              "button",
              {
                staticClass: "bb-badge badge-rounded",
                on: {
                  click: function ($event) {
                    _vm.searchTerm = ""
                  },
                },
              },
              [_c("i", { staticClass: "ki ki-close icon-md" })]
            ),
          ]),
          _c(
            "div",
            { staticClass: "clients-options-container" },
            [
              _c("BBCheckboxGroup", {
                attrs: {
                  options: _vm.clientsOptions,
                  elementId: "clients_checkboxes",
                  allCheckedLabel: _vm.$t(
                    "multipleClientSelect.selectAllLabel"
                  ),
                },
                model: {
                  value: _vm.selectedClientsIds,
                  callback: function ($$v) {
                    _vm.selectedClientsIds = $$v
                  },
                  expression: "selectedClientsIds",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.selectClients()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("multipleClientSelect.saveBtn")) + " ")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }